import React from 'react';
//import s from './Message.module.css';

const MessagesTwo = (props) => {
    return (
        <div>
            {props.message}
        </div>
    )
}

export default MessagesTwo;